import styled from 'styled-components';

const ClearIconMLStyled = styled.div`
  /* position: relative; */
  position: absolute;
  /* bottom: 0; */
  bottom: ${(props) => props.bottom || 0}px;
  /* right: 20px; */
  right: ${(props) => props.right || 20}px;
  .clear-btn-wrap {
    /* position: absolute; */
    .clear-icon {
      width: 12px;
      height: 12px;
    }
  }
`;
export default ClearIconMLStyled;
